import avatar from "../images/Admin/user.png";

export const user = {
  name: "Mahmud",
  surname: "Nurmuhammedov",
  email: "nmahmud0928@gmail.com",
  number: "998 (99) 909-09-09",
  password: "12345",
  img: avatar,
};
